import { useState } from "react";
import { usePhysicsTerms } from "./PhysicsTermChip";
import PhysicsFrame from "./PhysicsFrame";
import { loc } from "@/lib/physicsApi";
import { useT } from "@/i18n/LanguageContext";

export default function PhysicsGlossary() {
  const { lang } = useT();
  const terms = usePhysicsTerms();
  const [openId, setOpenId] = useState(null);
  return (
    <PhysicsFrame title="The Terms of Nature & Fate" crumb="Terms" testid="physics-glossary-page" canonicalPath="/terms">
      <p className="text-fog/80 font-reading max-w-2xl mb-12 leading-[1.9]">
        These terms carry the architecture of Stoic Physics. Each is given in its original form, in plain
        language, with its historical status, its practical meaning, and the misunderstanding to avoid.
        Inside the lessons these terms are clickable wherever they appear.
      </p>
      <div className="space-y-3">
        {terms.map((t) => {
          const open = openId === t.id;
          return (
            <div key={t.id} className="border border-[#c8a95a]/20 bg-[#14211a]">
              <button data-testid={`physics-glossary-term-${t.id}`} onClick={() => setOpenId(open ? null : t.id)} aria-expanded={open}
                className="w-full text-left px-6 py-4 flex items-baseline justify-between gap-4 focus:outline-none focus:ring-2 focus:ring-gold/60">
                <span className="flex items-baseline gap-4">
                  <span className="font-serif text-lg text-gold">{t.transliteration}</span>
                  <span className="font-serif text-base text-bone/40">{t.original}</span>
                </span>
                <span className="text-gold/60" aria-hidden>{open ? "−" : "+"}</span>
              </button>
              {open && (
                <div className="px-6 pb-6 space-y-4" data-testid={`physics-glossary-detail-${t.id}`}>
                  <p className="text-[15px] text-bone/90 font-reading leading-[1.85]">{loc(t.plain, lang)}</p>
                  <p className="text-sm text-fog font-reading leading-[1.85]"><span className="text-gold/70 text-xs tracking-[0.2em] uppercase">Historical status. </span>{loc(t.academic, lang)}</p>
                  <p className="text-sm text-fog/85 font-reading leading-[1.85]"><span className="text-gold/70 text-xs tracking-[0.2em] uppercase">Practical meaning. </span>{loc(t.application, lang)}</p>
                  <p className="text-sm text-fog/75 font-reading leading-[1.85]"><span className="text-[#7fb69a] text-xs tracking-[0.2em] uppercase">Common misunderstanding. </span>{loc(t.example, lang)}</p>
                  <div className="flex flex-wrap gap-x-6 gap-y-2 pt-3 border-t border-white/10 text-[11px] tracking-[0.15em] uppercase">
                    {t.related?.length > 0 && (
                      <span className="text-[#7fb69a]">Related: {t.related.map((r) => terms.find((x) => x.id === r)?.transliteration || r).join(", ")}</span>
                    )}
                    {t.lessons?.length > 0 && <span className="text-fog/50">Lessons {t.lessons.join(", ")}</span>}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </PhysicsFrame>
  );
}
